import { RegistrationFilter } from "../../rule-engine-core/Common/IRegistrationData";
import { FlowStepData } from "../../rule-engine-core/Flow/Steps/FlowStepData";
import { DataDefinition } from "../../rule-engine-core/Common/Data/DataDefinition";
import { FlowEditContext } from "../FlowEditContext";
import { FlowStepDataRegistration } from "../../rule-engine-core/Flow/Utilities/RegisterFlowStepData";
import { AppGlueError } from "../../rule-engine-core/AppGlueError";
import { BaseFlowStepEditor } from "../Steps/BaseFlowStepEditor";
import type { AppGlueAny } from "../../rule-engine-core/Common/AppGlueAny";

export class FlowStepEditorRegistrationData {
    category: string;
    type: string;
    name: string;
    icon: JSX.Element;
    include?: RegistrationFilter;
    private prototype: AppGlueAny;

    constructor(
        prototype: AppGlueAny,
        type: string,
        category: string,
        name: string,
        icon: JSX.Element,
        include?: RegistrationFilter,
    ) {
        this.prototype = prototype;
        this.category = category;
        this.type = type;
        this.name = name;
        this.icon = icon;
        this.include = include;
    }

    create(editContext: FlowEditContext, data?: FlowStepData): BaseFlowStepEditor {
        let editor = new this.prototype.constructor();

        editor.editContext = editContext;

        if (!data) {
            let dataReg = FlowStepDataRegistration.getByTypeName(this.type);

            if (!dataReg) throw new AppGlueError("no data registration found for " + this.type);

            data = dataReg.create();
        }

        editor.stepData = data;

        return editor;
    }
}

export function RegisterFlowEditor(
    step: BaseFlowStepEditor,
    forStep: FlowStepData,
    category: string,
    name: string,
    icon: JSX.Element,
    include?: RegistrationFilter,
) {
    let prototype = Object.getPrototypeOf(step);

    prototype.__type = forStep.__type;
    FlowStepEditorRegistration.addRegistration(
        new FlowStepEditorRegistrationData(prototype, forStep.__type, category, name, icon, include),
    );
}

export class FlowStepEditorRegistrationClass {
    private registrations: { [key: string]: FlowStepEditorRegistrationData } = {};

    addRegistration(data: FlowStepEditorRegistrationData) {
        this.registrations[data.type] = data;
    }

    getByTypeName(type: string): FlowStepEditorRegistrationData {
        return this.registrations[type];
    }

    getAll(forData?: DataDefinition): FlowStepEditorRegistrationData[] {
        let output: FlowStepEditorRegistrationData[] = [];

        Object.values(this.registrations).forEach((v) => {
            if (v.include) {
                // if it has a filter, will only add if there is data and there filter passes.
                if (forData && v.include(forData)) output.push(v);
            } else {
                output.push(v);
            }
        });

        return output;
    }

    getItemsByCategories(category?: string): { [key: string]: FlowStepEditorRegistrationData[] } {
        const itemsByCategory = this.getAll().reduce(
            (
                obj: {
                    [key: string]: FlowStepEditorRegistrationData[];
                },
                data,
            ) => {
                if (!category || (category && category === data.category)) {
                    if (!obj[data.category]) {
                        obj[data.category] = [];
                    }
                    obj[data.category].push(data);
                }
                return obj;
            },
            {},
        );

        return itemsByCategory;
    }
}

export const FlowStepEditorRegistration = new FlowStepEditorRegistrationClass();
